import {createStyles} from '@mantine/core';
import classNames from 'classnames';
import React from 'react';

import {loadingIndicatorAttrs} from 'notebook/util/ExportInstrumentation';

interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  classNames?: string;
  light?: boolean;
}

const Spinner = React.memo(
  ({classNames: classes, light, ...props}: SpinnerProps): JSX.Element => (
    <div
      aria-label={props['aria-label'] ?? 'Loading'}
      aria-live="polite"
      className={classNames('spinner', classes, {'spinner-light': light})}
      {...loadingIndicatorAttrs()}
      role="status"
      {...props}
    />
  )
);

Spinner.displayName = 'Spinner';

export default Spinner;

const useStyles = createStyles(() => ({
  centered: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

export function CenteredSpinner(props: SpinnerProps): JSX.Element {
  const {classes} = useStyles();
  return (
    <div className={classes.centered}>
      <Spinner {...props} />
    </div>
  );
}
